import React, {Component} from 'react';
import {connect} from 'react-redux';
import MyCheckbox from '../layout/Checkbox';
import Collapsible from '../layout/Collapsible';
import ArabicFilters from './ArabicFilters';
import FridaySermonArabicFilters from './FridaySermonArabicFilters';
import { searchAction } from '../../store/actions/searchActions';
import {
    toggleModalAction,
    addArabicIndexAction,
    removeArabicIndexAction,
    addArabicIndexesAction,
    removeArabicIndexesAction,
} from '../../store/actions/filtersActions';

export const ARABIC_SOURCES = [
    {
        id: 'arabic_books',
        label: 'Arabic Books',
        filters: <ArabicFilters showApplyButton={false} />,
    },
    {
        id: 'friday_sermon_new',
        label: 'Friday Sermon Arabic',
        filters: <FridaySermonArabicFilters showApplyButton={false} />,
    },
];

export class ArabicMaterialFilters extends Component {
    constructor(props) {
        super(props);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleSourceCheckbox = this.handleSourceCheckbox.bind(this);
        this.selectAllSources = this.selectAllSources.bind(this);
    }

    handleSourceCheckbox(e) {
        const source = e.target.id.replace('arabic-source-', '');
        if (e.target.checked) {
            this.props.addArabicIndex(source);
        } else {
            this.props.removeArabicIndex(source);
        }
    }

    selectAllSources(e) {
        if (e.target.checked) {
            this.props.addArabicIndexes(ARABIC_SOURCES.map(source => source.id));
        } else {
            this.props.removeArabicIndexes();
        }
    }

    applyFilters() {
        this.props.performSearch(
            document.querySelector('#search_field').value,
            this.props.filters
        );
        this.props.toggleModal(false);
    }

    render() {
        const selectedIndexes = this.props.filters.arabicIndexes || [];
        const allSelected = selectedIndexes.length === ARABIC_SOURCES.length;

        return <div>
            <span><strong>Content Collections</strong></span>&nbsp;
            <MyCheckbox
                checked={allSelected}
                onChange={this.selectAllSources}
                label="Select all"
                id="arabic-select-all"
            />
            <div className="display-flex" style={{flexWrap: 'wrap'}}>
                {ARABIC_SOURCES.map(source => <div
                    key={source.id}
                    className="width-content margin-left-40p"
                    style={{minWidth: '240px'}}
                >
                    <MyCheckbox
                        checked={selectedIndexes.includes(source.id)}
                        onChange={this.handleSourceCheckbox}
                        label={source.label}
                        id={`arabic-source-${source.id}`}
                    />
                </div>)}
            </div>

            {ARABIC_SOURCES
                .filter(source => selectedIndexes.includes(source.id))
                .map(source => <Collapsible
                    key={`${source.id}-filters`}
                    defaultExpanded={true}
                    header={`${source.label} Filters`}
                    body={source.filters}
                />)}

            <div className="apply-filters-container">
                <button
                    onClick={this.applyFilters}
                    className="btn apply-filters-btn margin-auto display-block"
                >
                    Apply and Search
                </button>
            </div>
        </div>;
    }
}

const mapStateToProps = state => ({
    filters: state.filters,
});

const mapDispatchToProps = dispatch => ({
    performSearch: (term, filters) => dispatch(searchAction(term, 0, filters)),
    toggleModal: value => dispatch(toggleModalAction(value)),
    addArabicIndex: index => dispatch(addArabicIndexAction(index)),
    removeArabicIndex: index => dispatch(removeArabicIndexAction(index)),
    addArabicIndexes: indexes => dispatch(addArabicIndexesAction(indexes)),
    removeArabicIndexes: () => dispatch(removeArabicIndexesAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArabicMaterialFilters);
